import React, { useState } from "react";
import { Box, Button, CircularProgress, IconButton, Tooltip, Typography, Stack } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SaveIcon from "@mui/icons-material/Save";
import Modal from "./Modal";

const BuildJsonModal = ({
  open,
  onClose,
  jsonData,
  loading = false,
  questionnaireId = null,
  onSave = null,
  savingJson = false,
  showOnly = false,
}) => {
  const [copiedToClipboard, setCopiedToClipboard] = useState(false);

  const handleCopyToClipboard = () => {
    if (jsonData) {
      const jsonString = JSON.stringify(jsonData, null, 2);
      navigator.clipboard.writeText(jsonString).then(() => {
        setCopiedToClipboard(true);
        setTimeout(() => setCopiedToClipboard(false), 2000);
      });
    }
  };

  const handleSave = () => {
    if (onSave && jsonData && questionnaireId) {
      onSave(questionnaireId, jsonData);
    }
  };

  return (
    <Modal open={open} handleClose={onClose} width="70%">
      <Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            JSON Generado del Cuestionario
          </Typography>
          <Tooltip title={copiedToClipboard ? "¡Copiado!" : "Copiar al portapapeles"}>
            <IconButton onClick={handleCopyToClipboard} disabled={loading} size="small">
              <ContentCopyIcon />
            </IconButton>
          </Tooltip>
        </Box>

        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
            <CircularProgress />
          </Box>
        ) : jsonData ? (
          <Box
            sx={{
              backgroundColor: "#f5f5f5",
              borderRadius: "4px",
              padding: "12px",
              maxHeight: "400px",
              overflowY: "auto",
              border: "1px solid #ddd",
            }}
          >
            <pre
              style={{
                fontFamily: "monospace",
                fontSize: "12px",
                margin: 0,
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",
              }}
            >
              {JSON.stringify(jsonData, null, 2)}
            </pre>
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", py: 3 }}>
            No hay datos para mostrar
          </Typography>
        )}

        <Stack direction="row" spacing={2} sx={{ mt: 3, justifyContent: "flex-end" }}>
          {jsonData && !showOnly && (
            <Button onClick={handleSave} color="success" variant="contained" startIcon={<SaveIcon />} disabled={savingJson || loading}>
              {savingJson ? "Guardando..." : "Guardar"}
            </Button>
          )}
          <Button onClick={onClose} color="primary" variant="contained" disabled={savingJson}>
            Cerrar
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default BuildJsonModal;
